<template>
  <div>
    <div class="f-c" v-if="isPC">
      <div class="content f">
        <div class="left-box bg-white time-filter">
          <h2>{{ groupsData.name }}</h2>
          <vue-scroll style="height: calc(100vh - 225px);">
            <div class="pointer" v-for="(item,index) in groupsList" :key="index" :class="{'is-active':index===activeTab}" @click="changeGroup(item,index)">{{ item.groupName }}</div>
          </vue-scroll>
        </div>
        <div style="padding: 0 0 0 280px;">
          <div class="banner-head">
            <oss-img :src="groupsData.bannerImgUrl" :width="702" :height="427" style="width:100%;border-radius: 12px;" />
          </div>
          <div class="product-filter f-e-c">
            <el-select v-model="listParams.countryCodeArray" multiple collapse-tags :placeholder="$t('inSrock.shippingFrom')" class="shipping-from" @change="resetPage()">
              <el-option v-for="item in shippingFromList" :key="item.countryCode" :label="item.countryCn" :value="item.countryCode"></el-option>
            </el-select>
            <Sort ref="sortCompoent"  style="margin-left: 15px;" @change="sortChange"></Sort>
            <el-input placeholder="Search" v-model="searchName" style="width:360px;margin-left:15px" class="inputGroup">
              <template slot="append">
                <el-button icon="el-icon-search" type="success" @click="searchHandle"></el-button>
              </template>
            </el-input>
          </div>
          <div class="product-list f fw-w " v-loading="listLoading">
            <Product v-for="item in saleProductList" :key="item.kkProductId" :product="item" :currentWarehouse="country || ''" :noChangeWarehouse="country && true" class="product-item" kklocation="albumList" reportType="album"></Product>
          </div>
          <div v-if="!saleProductList.length && !listLoading" class="empty">
            <div class="f-c-c fd-c">
              <img src="@/assets/img/activity_empty.svg" alt="">
              <p>{{ $t('Index.Album.Components.TemplateTwo.NoProductFound') }}</p>
            </div>
          </div>
          <div class="f-e" style="padding:15px 0" v-show="saleProductList.length>0">
            <el-pagination @size-change="handleSizeChange" @current-change="resetPage" :current-page.sync="listParams.pageNumber" :page-sizes="[20, 40, 60,80, 100]" :page-size="listParams.pageSize" layout=" prev, pager, next,sizes" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="mobile-newin bg-white">
      <oss-img :src="groupsData.bannerImgUrl" :width="344" :height="46" style="width: 100%;height:1rem"></oss-img>
      <div :class="[fixFilter?'fix-filter':'']">
        <van-dropdown-menu>
          <van-dropdown-item v-model="mobileActiveTab" :title="mobileActiveTab" :options="dateLineList" @change="value => mobileGroupChange(value)"></van-dropdown-item>
          <van-dropdown-item v-model="mobileShipFrom" title="Ship From">
            <van-cell center :title="item.countryCn" v-for="item in shippingFromList" :class="[item.checked?'checked-country':'']" :key="item.countryCn" @click="shipFromChangeMobile(item)">
              <template #right-icon>
                <i class="el-icon-check" v-if="item.checked"></i>
              </template>
            </van-cell>
          </van-dropdown-item>
          <van-dropdown-item :options="sortListForMobile" @change="value => sortChangeMobile(value)" v-model="sortKeyForMobile"></van-dropdown-item>
        </van-dropdown-menu>

      </div>
      <div class="product-list f-b-c fw-w " v-loading="listLoading">
        <Product v-for="item in saleProductList" :key="item.kkProductId" :product="item" :currentWarehouse="country || ''" :noChangeWarehouse="country && true" class="product-item" kklocation="albumList" reportType="album"></Product>
      </div>
      <div v-if="!saleProductList.length && !listLoading" class="empty">
        <div class="f-c-c fd-c">
          <img src="@/assets/img/activity_empty.svg" alt="">
          <p>{{ $t('Index.Album.Components.TemplateTwo.NoProductFound') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import Sort from '@/views/commodity/components/Sort.vue'
import Product from '@/components/Product.vue'
import getSortOptions from '@/config/sortOptions.js'

import DropdownMenu from 'vant/lib/dropdown-menu'
import 'vant/lib/dropdown-menu/style'
import DropdownItem from 'vant/lib/dropdown-item'
import 'vant/lib/dropdown-item/style'
import cell from 'vant/lib/cell'
import 'vant/lib/cell/style'
import 'vant/lib/icon/style'
export default {
  components: {
    Sort,
    Product,
    'van-dropdown-menu': DropdownMenu,
    'van-dropdown-item': DropdownItem,
    'van-cell': cell
  },
  data() {
    return {
      moduleId: '',
      listLoading: false,
      groupsData: {},
      groupsList: [],
      listParams: {
        pageNumber: 1,
        pageSize: 40,
        groupId: undefined
      },
      total: 0,
      activeTab: '', // 选中的组
      searchName: '', // 搜索内容
      shippingFromList: [], // 发货国家
      saleProductList: [],

      fixFilter: false, // 移动端固定顶部
      mobileActiveTab: '',
      mobileShipFrom: [],
      sortKeyForMobile: 1,
      country: '' // 选中的仓库国家
    }
  },
  computed: {
    sortListForMobile() {
      const arr = getSortOptions.call(this)
      arr.forEach(e => {
        e.text = e.name
        e.value = e.key
      })
      return arr
    },
    dateLineList() {
      let arr = _.cloneDeep(this.groupsList)
      arr = arr.map((item, index) => ({
        text: item.groupName, value: item.groupName || item.groupId, id: item.groupId
      }))
      return arr
    }
  },
  created() {
    this.getShippingFromList()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.scroll)
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll)
  },
  methods: {
    // 初始化
    init(groupsData, moduleId) {
      this.moduleId = moduleId || this.$route.query.moduleId
      groupsData.groupsList = groupsData.groupsList.map(item => ({ ...item, groupId: item.groupId ? (item.groupId + '') : undefined }))
      this.groupsData = _.cloneDeep(groupsData)
      this.groupsList = groupsData.groupsList
      if (+this.groupsData.level === 2) {
        this.$set(this.listParams, 'groupId', this.groupsList[0].groupId || undefined)
        this.$set(this.listParams, 'groupName', this.groupsList[0].groupName || undefined)
        if (this.isPC) this.$set(this.$data, 'activeTab', 0)
        else this.$set(this.$data, 'mobileActiveTab', this.groupsList[0].groupName)
        this.$set(this.$data, 'country', this.groupsList[0].country || undefined)
      }
      this.getAlbumModuleList()
    },

    // 专辑全部商品
    getAlbumModuleList() {
      this.listLoading = true
      this.listParams.moduleId = this.moduleId || this.$route.query.moduleId
      if (!this.isPC) {
        let countryCodeArray = this.shippingFromList.filter(e => e.checked).map(e => e.countryCode)
        this.listParams.countryCodeArray = countryCodeArray.length ? countryCodeArray : undefined
      }
      API.getAlbumModuleList(this.listParams).then(({ data }) => {
        this.saleProductList = data.list
        this.total = data.total
        this.totalPage = Math.ceil(this.total / this.listParams.pageSize)
        this.saleEndTime = data.list.length && data.list[0].endTime
        document.body.scrollTop = document.documentElement.scrollTop = 0
      }).finally(() => {
        this.listLoading = false
      })
    },

    // 切换分组
    changeGroup(item, index) {
      this.$set(this.$data, 'activeTab', index)
      this.$set(this.listParams, 'groupId', item.groupId || undefined)
      this.$set(this.listParams, 'groupName', item.groupName || undefined)
      this.$set(this.$data, 'country', item.country || undefined)
      this.resetPage()
    },
    mobileGroupChange(value) {
      this.groupsList.forEach(item => {
        if (item.groupName === value) {
          this.$set(this.$data, 'mobileActiveTab', item.groupName)
          this.$set(this.listParams, 'groupId', item.groupId || undefined)
          this.$set(this.listParams, 'groupName', item.groupName || undefined)
          this.$set(this.$data, 'country', item.country || undefined)
          this.resetPage()
        }
      })
    },

    // 筛选
    sortChange(sortName, sortType) {
      this.filterVisible = false
      this.listParams.sortName = sortName
      this.listParams.sortType = sortType
      this.resetPage()
    },
    sortChangeMobile(value) {
      const { sortName, sortType } = this.sortListForMobile.find(e => e.value === value)
      this.sortChange(sortName, sortType)
    },

    // 搜索格式化
    searchHandle() {
      this.listParams.searchName = this.searchName ? this.searchName.split(',') : undefined
      this.resetPage()
    },

    resetPage(val) {
      this.listParams.pageNumber = val || 1
      this.getAlbumModuleList()
    },

    handleSizeChange(val) {
      this.listParams.pageSize = val || 40
      this.getAlbumModuleList()
    },

    scroll() {
      if (this.isPC) {
        return
      }
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop > (this.$route.path.includes('/sale') ? 115 : 50)) {
        this.fixFilter = true
      } else {
        this.fixFilter = false
      }
      if (scrollTop + windowHeight - scrollHeight > -200 && !this.listLoading && this.saleProductList.length < this.total) {
        this.listParams.pageNumber++
        this.getAlbumModuleList()
      }
    },

    getShippingFromList() {
      API.getShippingFromList({
        pageSize: 100,
        pageNumber: 1
      }).then(result => {
        // 以国家编码去重
        const map = {}
        result.data.list.forEach(item => {
          if (['CN_N', 'CN_S'].includes(item.countryCode)) {
            map['CN'] = {
              countryCn: 'China',
              countryCode: 'CN'
            }
            return
          }
          map[item.countryCode] = {
            countryCn: item.countryCn,
            countryCode: item.countryCode
          }
        })
        this.shippingFromList = Object.values(map)
      })
    },
    shipFromChangeMobile(value) {
      this.$set(value, 'checked', !value.checked)
      this.resetPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  max-width: 1400px;
  min-width: 1000px;
  padding: 0 15px;
  .left-box {
    // margin-top: 30px;
    width: 250px;
    margin-right: 16px;
    border: 1px solid #f4f6f9;
    padding: 30px 0 0 0;
    padding-left: 0px;

    h2 {
      padding-bottom: 23px;
      color: #1f2937;
      font-weight: 600;
      font-size: 16px;
      padding-left: 25px;
      line-height: 24px;
    }
    div {
      font-weight: 400;
      font-size: 14px;
      width: 100%;
      padding-left: 25px;
      line-height: 40px;
      color: #747a87;
    }
  }

  .inputGroup {
    /deep/.el-input__inner {
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
    }
    /deep/.el-input-group__append {
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
      background-color: rgba(153, 196, 28, 0.2);
    }
  }

  .product-filter {
    margin-bottom: 15px;

    .shipping-from {
      /deep/ .el-select__tags-text{
        max-width: 66px;
      }
    }

  }
  .product-list {
    /deep/ .title-price {
      margin-top: 8px;
    }
  }

  .empty {
    padding: 20px;
    p {
      margin-top: 20px;
    }
  }

  .product-item {
    width: 24%;
    margin: 0 0.5% 20px;
  }
  .is-active {
    background: rgba(153, 196, 28, 0.06);
    color: #99c41c !important;
  }
}
.banner-head {
  max-width: 1380px;
  border-radius: 12px;
  padding: 30px 0 5px 0;
  img {
    width: 100%;
    border-radius: 12px;
    object-fit: contain;
  }
}

.mobile-newin{
  padding: 0.2rem 0.3rem;
  min-height: calc(100vh - 0.9rem);

  /deep/.van-dropdown-menu__bar{
    box-shadow: none;
  }

  .product-item {
    width: 48%;
    margin-bottom: 20px;
  }

  .empty {
    padding: 20px;
    img {
      width: 60%;
    }
    p {
      margin-top: 20px;
    }
  }

  .fix-filter{
    width: 100%;
    // height: 40px;
    background: #fff;
    position: fixed;
    top: 0.85rem;
    left: 0;
    z-index: 10;
    padding:0 0.3rem;
  }

  /deep/.van-dropdown-item__option--active {
    color: #99C41C;
    background: rgba(153, 196, 28, 0.04);
  }
  /deep/.van-dropdown-item__icon{
    color: #99C41C;
  }

  /deep/.van-dropdown-menu__title--active {
    color: #99C41C;
  }
  /deep/.van-cell .van-cell--center{
    color: #99C41C;
  }

  /deep/.el-icon-check{
    color: #99C41C;
  }
  .checked-country{
    color: #99C41C;
    background: rgba(153, 196, 28, 0.04);
  }
}
.time-filter{
    position: fixed;
    bottom: 0;
    left: calc((100vw - 1400px) / 2);
}
@media screen and (min-width:1000px) and(max-width: 1400px ) {
  .time-filter{
    left: 15px!important;
  }
}
</style>
